import { logError } from '@/src/utils/logError'

export const ClevertapAndroid = {
    event(name: string, payload: Object) {
        try {
            if (window.ClevertapInterface) {
                if (payload) {
                    window.ClevertapInterface.pushEvent(name, JSON.stringify(payload))
                } else {
                    window.ClevertapInterface.pushEvent(name)
                }
            }
        } catch (e) {
            logError('ClevertapAndroid', e)
        }
    }
}
